import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import { Link } from '@inertiajs/inertia-vue3';

import { ElMessageBox, ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  components: {
    Head: Head,
    Link: Link
  },
  layout: Layout,
  props: {},
  data: function data() {
    return {
      resourceList: [],
      isLoadingMapping: false
    };
  },
  mounted: function mounted() {
    this.getUserList(true);
  },
  methods: {
    getUserList: function getUserList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoadingMapping = true;
                _context.next = 3;
                return axios.post('/get_leaderboard_mapping');
              case 3:
                res = _context.sent;
                if (res.data.status == 'success') {
                  _this.resourceList = res.data.userList;
                }
                _this.isLoadingMapping = false;
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    disableUser: function disableUser(userData) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var performAction, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                performAction = true;
                _context2.next = 3;
                return ElMessageBox.confirm(userData.is_team ? 'Are you sure to enable this user.' : 'Are you sure to disable this user', 'Warning', {
                  confirmButtonText: 'Confirm',
                  cancelButtonText: 'Cancel',
                  type: 'warning'
                }).then(function () {})["catch"](function () {
                  ElMessage({
                    type: 'info',
                    message: 'Canceled'
                  });
                  performAction = false;
                });
              case 3:
                if (performAction) {
                  _context2.next = 5;
                  break;
                }
                return _context2.abrupt("return", performAction);
              case 5:
                _this2.$store.loading = true;
                _context2.next = 8;
                return axios.post('/save_leader_board_mapping', userData);
              case 8:
                res = _context2.sent;
                ElMessage({
                  type: res.data.status,
                  message: res.data.msg
                });
                _this2.getUserList();
                _this2.$store.loading = false;
              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};